import React from 'react';

const AdminEventsSkeleton: React.FC = () => (
    <div className="flex my-6 flex-col align-start gap-8 overflow-visible animate-pulse">
      {/* Header */}
      <div className="flex items-center gap-4 self-stretch">
        <div className="h-10 w-56 bg-neutral-200 dark:bg-neutral-700 rounded-2xl"></div>
      </div>

      {/* Create Event Card */}
      <div className="flex flex-col md:flex-row p-4 justify-between self-stretch gap-4 items-center text-center glass-surface rounded-3xl">
        <div className="h-6 w-64 bg-neutral-200 dark:bg-neutral-700 rounded"></div>
        <div className="h-10 w-40 bg-neutral-200 dark:bg-neutral-700 rounded-2xl"></div>
      </div>

      {/* Search Controls */}
      <div className="flex flex-col w-full md:flex-row gap-4 items-center">
        <div className="w-full rounded-3xl h-12 bg-neutral-200 dark:bg-neutral-700"></div>
        <div className="w-64 h-12 bg-neutral-200 dark:bg-neutral-700 rounded-3xl"></div>
        <div className="w-40 h-12 bg-neutral-200 dark:bg-neutral-700 rounded-3xl"></div>
      </div>

      {/* Event Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 glass-surface">
        {[...Array(6)].map((_, index) => (
          <div key={index} className="w-full">
            <div className="group flex flex-col items-center w-full h-full p-3 rounded-3xl landing-event-card-shadow bg-blur-lg bg-opacity-heavy gap-3">
              <div className="w-full relative rounded-2xl">
                <div className='overflow-hidden rounded-2xl'>
                  <div className="w-full aspect-[1920/700] bg-neutral-200 dark:bg-neutral-700" />
                </div>
              </div>
              <div className="flex flex-col items-center w-full gap-3 h-full">
                <div className="h-6 w-3/4 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
                <div className="h-4 w-1/2 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
                <div className="h-4 w-2/3 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
                <div className='flex h-full items-end w-fit mb-3'>
                  <div className="h-10 w-40 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
);

export default AdminEventsSkeleton;
